module.exports = __webpack_public_path__ + "static/img/bg-kiko.6b04730e.webp";